import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ModalStateModuleName } from '@/store/modules/modules'

export class ModalStateViewModel {
  private store = useStore()

  isShowLoginModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowLoginModal`]
  )

  isShowProblemSearchModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowProblemSearchModal`]
  )

  isShowArenaModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowArenaModal`]
  )

  isShowDashboardModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowDashboardModal`]
  )

  isShowUpdateModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowUpdateModal`]
  )

  isShowFreeSpaceModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowFreeSpaceModal`]
  )

  isShowReviewAlertModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowReviewAlertModal`]
  )

  isShowSettingsModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowSettingsModal`]
  )

  isShowUserRegistrationModal: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModalStateModuleName}/isShowUserRegistrationModal`]
  )

  setIsShowLoginModal(isShowLoginModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowLoginModal`, isShowLoginModal)
  }

  setIsShowProblemSearchModal(isShowProblemSearchModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowProblemSearchModal`, isShowProblemSearchModal)
  }

  setIsShowArenaModal(isShowArenaModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowArenaModal`, isShowArenaModal)
  }

  setIsShowDashboardModal(isShowDashboardModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowDashboardModal`, isShowDashboardModal)
  }

  setIsShowUpdateModal(isShowUpdateModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowUpdateModal`, isShowUpdateModal)
  }

  setIsShowFreeSpaceModal(isShowFreeSpaceModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowFreeSpaceModal`, isShowFreeSpaceModal)
  }

  setIsShowReviewAlertModal(isShowReviewAlertModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowReviewAlertModal`, isShowReviewAlertModal)
  }

  setIsShowSettingsModal(isShowSettingsModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowSettingsModal`, isShowSettingsModal)
  }

  setIsShowUserRegistrationModal(isShowUserRegistrationModal: boolean): void {
    this.store.commit(`${ModalStateModuleName}/setIsShowUserRegistrationModal`, isShowUserRegistrationModal)
  }
}
